import {useAppliedFiltersList} from 'plugins/modules/filter/hooks/AppliedFilters/useAppliedFiltersList';
import {ShowFiltersButton} from 'plugins/modules/filter/components/ShowFiltersButton';
import {FilterContext} from 'plugins/modules/filter/context/new';
import React, {FC, useContext, useMemo} from 'react';
import style from './style.module.scss';
import {HorizontalScrollContainer} from 'components/HorizontalScrollContainer';
import ExpressOrderAppliedFilter from 'plugins/modules/filter/components/AppliedFilters/ExpressOrderAppliedFilter';
import {FilterPickupTodayButtonContext} from 'plugins/modules/filter/context/FilterPickupTodayButtonContext';
import {useOptimisticAppliedFilters} from 'plugins/modules/filter/hooks/AppliedFilters/useOptimisticAppliedFilters';
import {useListingContext} from 'plugins/modules/listing/context';
import {SkeletonWrapper} from 'modules/skeleton/components/SkeletonWrapper';

const SHOW_FILTERS_COUNT = 3;

export const AppliedFilters: FC = () => {
    const {isFetching} = useListingContext();
    const {appliedFilters} = useContext(FilterContext);
    const {wineShop} = useContext(FilterPickupTodayButtonContext);

    const {optimisticFilters} = useOptimisticAppliedFilters(appliedFilters);

    const isShowButton = SHOW_FILTERS_COUNT < optimisticFilters.length;

    const last3AppliedFilters = useMemo(() => {
        return optimisticFilters.slice(-SHOW_FILTERS_COUNT);
    }, [optimisticFilters]);

    const list = useAppliedFiltersList(last3AppliedFilters);

    if (0 === list.length && !wineShop) {
        return null;
    }

    return (
        <SkeletonWrapper disabled={!isFetching}>
            <div className={style.main}>
                <div className={style.filterItems}>
                    {isShowButton && <ShowFiltersButton appliedFilters={appliedFilters} key={'filter-button'} />}
                    <HorizontalScrollContainer className={style.itemsPreview}>
                        <ExpressOrderAppliedFilter />
                        {list}
                    </HorizontalScrollContainer>
                </div>
            </div>
        </SkeletonWrapper>
    );
};
